import { render, staticRenderFns } from "./AppEditableHeader.vue?vue&type=template&id=02878ad3&scoped=true&"
import script from "./AppEditableHeader.vue?vue&type=script&lang=ts&"
export * from "./AppEditableHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02878ad3",
  null
  
)

export default component.exports